var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToPermIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.691,
    height: 12.11,
    viewBox: "0 0 9.691 12.11",
    style: {
      transform: "scale(1.3)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14504",
    "data-name": "Group 14504",
    transform: "translate(511 -109.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-501.845,115.145a6.084,6.084,0,0,1-.4,2.291c-.509,1.055-2.909,2.764-3.927,3.564-1.018-.8-3.382-2.509-3.927-3.564a6.059,6.059,0,0,1-.364-2.291c-.036-1.564-.036-3.127-.036-4.655a19.478,19.478,0,0,1,8.691,0C-501.809,112.018-501.809,113.582-501.845,115.145Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-476.484,153.17a3.226,3.226,0,0,0-3.226,3.226,3.226,3.226,0,0,0,3.226,3.225,3.226,3.226,0,0,0,3.226-3.225A3.226,3.226,0,0,0-476.484,153.17Zm-.874,4.859-1.106-1.106.412-.411.694.694,2.443-2.443.412.412Z",
    transform: "translate(-29.67 -41.6)",
    fill: "var(--mainColor)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToPermIcon);
export default __webpack_public_path__ + "static/media/addToPermIcon.f3a73d378a71ba1fa6150a0aecc1db53.svg";
export { ForwardRef as ReactComponent };